import React from 'react';
import {View} from 'react-native';

import Gutter from '/component/layout/Gutter';
import {ProfileHeader} from '/component/screen/CandidateProfile/ProfileHeader';

import {styles} from './Header.style';
interface HeaderProps {
  name: string;
  source: string;
  createdOn: string;
  candidateId: string | null;
}

export const Header: React.FC<HeaderProps> = ({
  name = '',
  source = '',
  createdOn = '',
  candidateId = null,
}) => (
  <View style={styles.base}>
    <Gutter>
      <ProfileHeader
        name={name}
        source={source}
        createdOn={createdOn}
        // @ts-expect-error TS(2322): Type '{ name: any; source: any; createdOn: any; op... Remove this comment to see the full error message
        optaviaId={candidateId}
      />
    </Gutter>
  </View>
);

export default Header;
